/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OldHousingDataImportApplicationsResponseDto } from '../models/OldHousingDataImportApplicationsResponseDto';
import type { OldHousingDataImportMappingsResponseDto } from '../models/OldHousingDataImportMappingsResponseDto';
import type { OldHousingDataImportRequestDto } from '../models/OldHousingDataImportRequestDto';
import type { OldHousingDataImportResultDto } from '../models/OldHousingDataImportResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OldHousingDataImportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns OldHousingDataImportApplicationsResponseDto OK
     * @throws ApiError
     */
    public postApiHousingOldHousingDataImportApplications(
        requestBody?: OldHousingDataImportRequestDto,
    ): CancelablePromise<OldHousingDataImportApplicationsResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/OldHousingDataImport/Applications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns OldHousingDataImportResultDto OK
     * @throws ApiError
     */
    public postApiHousingOldHousingDataImportPreview(
        requestBody?: OldHousingDataImportRequestDto,
    ): CancelablePromise<OldHousingDataImportResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/OldHousingDataImport/Preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns OldHousingDataImportResultDto OK
     * @throws ApiError
     */
    public postApiHousingOldHousingDataImportExecute(
        requestBody?: OldHousingDataImportRequestDto,
    ): CancelablePromise<OldHousingDataImportResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/OldHousingDataImport/Execute',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns OldHousingDataImportMappingsResponseDto OK
     * @throws ApiError
     */
    public getApiHousingOldHousingDataImportMappings(): CancelablePromise<OldHousingDataImportMappingsResponseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/OldHousingDataImport/Mappings',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
